import { Routes, Route } from 'react-router-dom';

import PasswordResetRecovery from './features/recovery';
import PasswordResetRequest from './features/request';

function ForgottenPasswordFeature() {
  return (
    <Routes>
      <Route index element={<PasswordResetRequest />} />
      <Route path="recovery" element={<PasswordResetRecovery />} />
    </Routes>
  );
}

export default ForgottenPasswordFeature;
